import * as React from "react";
import {
    CommandBar,
} from "@fluentui/react/";
import { comandBarS } from "./../../../features/commandBar/styles/commandBar.styles";

const InternalStoreCommandBar: React.FC = () => {
    // const { items } = useReportsCommandBar()
    return <CommandBar items={[]} styles={comandBarS} />;
}

export default InternalStoreCommandBar;